import React from 'react'

const Author = ({
    children,
    isMe
}) => {

    if (isMe) {
        return null
    }
    return (
        <div
            style={{
                paddingLeft: '15px',
                verticalAlign: 'bottom',
                color: 'rgb(110, 110, 110)'
            }}
        >
            <small>{children}</small>
        </div>
    )
}

export default Author
